import * as React from "react";
import PagedDataGrid from "../DataGrid/PagedDataGrid";

type InstalledBaseItemGroupProps = {
    productId: string;
    headers: string[];
    title: string;
    detailsName: string;
};

export const InstalledBaseItemGroup: React.FC<InstalledBaseItemGroupProps> = (
    props: InstalledBaseItemGroupProps
) => {
    return (
        <div className="ItemGroup">
            <h3 className="ItemGroup__title">{props.title}</h3>
            <PagedDataGrid
                headers={props.headers}
                route={`/api/products/${props.productId}/assets`}
                // title={props.title} this is unused
                name={props.detailsName}
                exportable={true}
            />
        </div>
    );
};
